import EndUserCardCarouselSlider from '../end-user-search/EndUserCardCarouselSlider';
import EndUserSlider from '../end-user-search/EndUserSlider';
import ExploreUdemyPanel from '../end-user-search/ExploreUdemyPanel';
import NavbarIconsGenericComponent from '../generic-nav-bar/NavbarIconsGenericComponent';
import { useSelector } from 'react-redux';

const DashboardApp = () => {
    const { exploreUdemyDashboardEnabled } = useSelector((state) => state.configuration);
    const udemyOn = String(exploreUdemyDashboardEnabled) === 'true';

    return (
        <div>
            <NavbarIconsGenericComponent componentName="Dashboard" />
            <div className="row">
                <EndUserSlider />
            </div>
            <div className="row">
                <EndUserCardCarouselSlider />
            </div>
            {udemyOn && <ExploreUdemyPanel />}
        </div>
    );
};

export default DashboardApp;
